import { render, staticRenderFns } from "./airplane-carousel.vue?vue&type=template&id=58933427&scoped=true"
import script from "./airplane-carousel.vue?vue&type=script&lang=js"
export * from "./airplane-carousel.vue?vue&type=script&lang=js"
import style0 from "./airplane-carousel.vue?vue&type=style&index=0&id=58933427&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58933427",
  null
  
)

export default component.exports